export default __webpack_public_path__ + "static/media/147.5506549f.jpg";